export default __webpack_public_path__ + "static/media/check-blue.06cfa9e9.svg";